import * as React from "react";
import { useTranslation } from "react-i18next";
import { ReadOnlyFormGroup } from "components/common";
const DataLakeStatus = ({ dataLakeEnabled }) => {
  const { t } = useTranslation("enterprise_data_lake");
  return /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: t("status.enabled"), value: dataLakeEnabled || false });
};
export default DataLakeStatus;
